import { Link } from "react-router-dom";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import { FaShoppingCart } from "react-icons/fa"; // ✅ add cart icon
import { useContext } from "react";
import { CartContext } from "../context/CartContext"; // ✅ cart context
import "./Navbar.css";

function ProbiomaNavbar() {
  const { cart } = useContext(CartContext);

  return (
    <Navbar expand="lg" className="probioma-navbar shadow-sm">
      <Container>
        <Navbar.Brand as={Link} to="/" className="brand-text">
          <img 
            src="/favicon.ico" 
            alt="Probioma Logo" 
            width="24" 
            height="24" 
            style={{ marginRight: "8px" }}
          />
           Probioma
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="ms-auto align-items-center">
            <Nav.Link as={Link} to="/">Home</Nav.Link>
            <Nav.Link as={Link} to="/shop">Shop</Nav.Link>
            <Nav.Link as={Link} to="/about-us">About Us</Nav.Link>
            <Nav.Link as={Link} to="/wholesale">Wholesale</Nav.Link>

            {/* ✅ Cart Icon with badge */}
            <Nav.Link as={Link} to="/cart" className="position-relative ms-3">
              <FaShoppingCart size={22} />
              {cart.length > 0 && (
                <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger">
                  {cart.reduce((sum, item) => sum + item.qty, 0)}
                </span>
              )}
            </Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default ProbiomaNavbar;
